import { sendTrackingLog } from '../data/api'
import {
  getErrorDescription,
  MEDIAFILE_COULD_NOT_BE_FOUND,
  UNDEFINED_ERROR,
  VAST_SCHEMA_VALIDATION_ERROR,
  VAST_VERSION_NOT_SUPPORTED,
  XML_PARSING_ERROR
} from './vast-error-handler'
import { setTrackingEvent } from './vast-tracking'

export const parseVast = (vastString, isJustParse = false, adexchangeId = '') => {
  try {
    const xmlDoc = new DOMParser().parseFromString(vastString, 'text/xml')

    const parserError = xmlDoc.getElementsByTagName('parsererror')
    if (parserError.length) {
      console.error('VAST XML parsing error:', parserError[0].textContent)

      // Track XML parsing error
      if (adexchangeId) {
        sendTrackingLog({
          adexchangeId,
          eventType: 'error',
          errorCode: XML_PARSING_ERROR,
          description: getErrorDescription(XML_PARSING_ERROR)
        })
      }

      return null
    }

    // Check VAST version support
    const vast = xmlDoc.getElementsByTagName('VAST')[0]
    if (vast) {
      const vastVersion = vast.getAttribute('version')
      if (vastVersion && !['2.0', '3.0', '4.0'].includes(vastVersion)) {
        console.error(`VAST version ${vastVersion} not supported`)

        // Track version not supported error
        if (adexchangeId) {
          sendTrackingLog({
            adexchangeId,
            eventType: 'error',
            errorCode: VAST_VERSION_NOT_SUPPORTED,
            description: getErrorDescription(VAST_VERSION_NOT_SUPPORTED)
          })
        }

        return null
      }
    }

    const ads = xmlDoc.getElementsByTagName('Ad')
    if (!ads.length) {
      console.error('No Ad element found in VAST response')

      // Track schema validation error
      if (adexchangeId) {
        sendTrackingLog({
          adexchangeId,
          eventType: 'error',
          errorCode: VAST_SCHEMA_VALIDATION_ERROR,
          description: getErrorDescription(VAST_SCHEMA_VALIDATION_ERROR)
        })
      }

      return null
    }

    const inLine = ads[0].getElementsByTagName('InLine')
    if (!inLine.length) {
      console.error('No Ad element found in VAST response')

      // Track schema validation error
      if (adexchangeId) {
        sendTrackingLog({
          adexchangeId,
          eventType: 'error',
          errorCode: VAST_SCHEMA_VALIDATION_ERROR,
          description: getErrorDescription(VAST_SCHEMA_VALIDATION_ERROR)
        })
      }

      return null
    }

    const creatives = inLine[0].getElementsByTagName('Creative')
    if (!creatives.length) {
      if (adexchangeId) {
        sendTrackingLog({
          adexchangeId,
          eventType: 'error',
          errorCode: VAST_SCHEMA_VALIDATION_ERROR,
          description: getErrorDescription(VAST_SCHEMA_VALIDATION_ERROR)
        })
      }
      return null
    }

    const linear = creatives[0].getElementsByTagName('Linear')[0]
    if (!linear) {
      if (adexchangeId) {
        sendTrackingLog({
          adexchangeId,
          eventType: 'error',
          errorCode: VAST_SCHEMA_VALIDATION_ERROR,
          description: getErrorDescription(VAST_SCHEMA_VALIDATION_ERROR)
        })
      }
      return null
    }

    const mediaFiles = linear.getElementsByTagName('MediaFile')
    if (!mediaFiles.length) {
      if (adexchangeId) {
        sendTrackingLog({
          adexchangeId,
          eventType: 'error',
          errorCode: MEDIAFILE_COULD_NOT_BE_FOUND,
          description: getErrorDescription(MEDIAFILE_COULD_NOT_BE_FOUND)
        })
      }
      return null
    }

    // Find best media file (prefer MP4)
    const selectedMediaFile = pickBestMedia(mediaFiles)

    const mediaUrl = extractNodeData(selectedMediaFile)
    if (!mediaUrl) {
      if (adexchangeId) {
        sendTrackingLog({
          adexchangeId,
          eventType: 'error',
          errorCode: MEDIAFILE_COULD_NOT_BE_FOUND,
          description: getErrorDescription(MEDIAFILE_COULD_NOT_BE_FOUND)
        })
      }
      return null
    }

    if (!isJustParse) {
      setTrackingEvent(linear, inLine[0])
    }

    return mediaUrl
  } catch (error) {
    console.error('Error parse vast :', error)

    // Track general initialization error
    if (adexchangeId) {
      sendTrackingLog({
        adexchangeId,
        eventType: 'error',
        errorCode: UNDEFINED_ERROR,
        description: getErrorDescription(UNDEFINED_ERROR)
      })
    }

    return null
  }
}

const pickBestMedia = (mediaFiles) => {
  let selectedMediaFile = null
  for (let i = 0; i < mediaFiles.length; i++) {
    const mediaFile = mediaFiles[i]
    const type = mediaFile.getAttribute('type')
    if (type && type.includes('mp4')) {
      selectedMediaFile = mediaFile
      break
    }
  }

  if (!selectedMediaFile) {
    selectedMediaFile = mediaFiles[0] // Fallback to first available
  }
  return selectedMediaFile
}

export const extractNodeData = (input) => {
  let data = ''
  for (let i = 0; i < input.childNodes.length; i++) {
    const node = input.childNodes[i]
    if (
      node.nodeType !== Node.COMMENT_NODE &&
      !(node.nodeType === Node.TEXT_NODE && /^\s*$/.test(node.textContent))
    ) {
      data += node.textContent
    }
  }
  return data.replace(/(^\s+|\s+$)/g, '')
}

export const sanityCheckUrl = (uri, flag = false) => {
  if (typeof uri === 'undefined') {
    return null
  }

  let cleanUrl = uri
    .replace('<![CDATA[', '')
    .replace(']]>', '')
    .replace('[VIEWABILITY]', '')
    .replace('[GOOGLE_VIEWABILITY]', '')
    .replace('[AD_MT]', '')
    .replace('[ERRORCODE]', '')
    .replace('[URL_SIGNALS]', '0,https%253A%252F%252Fpub.movingwalls.com')

  if (!flag) {
    cleanUrl = cleanUrl.replace(
      'https://bid.g.doubleclick.net/dbm/vast',
      'https://pub.movingwalls.com/dbm'
    )
  }

  if (cleanUrl.indexOf('sdkv=') === -1) {
    cleanUrl += '&sdkv=h.3.510.1'
  }

  return cleanUrl
}
